import React from "react";

interface ICustomLegendProps {
  totalEnrolments: number;
  colorValueMap: Record<string, string>;
}

const CustomLegend: React.FC<ICustomLegendProps> = (props) => {
  const { totalEnrolments, colorValueMap } = props;

  return (
    <div className="custom-legend">
      {/* CATEGORIES WITH COLOR-VALUE PAIRS */}
      <div>
        {Object.entries(colorValueMap).map(([category, color]) => (
          <span key={category} className="custom-legend-categories">
            <svg width="16" height="16" style={{ marginRight: 5 }}>
              <rect width="16" height="16" fill={color} rx="3" />
            </svg>
            {category}
          </span>
        ))}
      </div>
      {/* TOTAL ENROLMENT COUNT */}
      <div className="custom-legend-enrolment-count">
        <span
          style={{
            fontWeight: "bold",
            fontSize: 20,
            marginRight: 6,
          }}
        >
          {totalEnrolments}
        </span>
        <span
          style={{
            color: "#757575",
            fontSize: 17,
            fontWeight: 450,
          }}
        >
          Total Enrolments
        </span>
      </div>
    </div>
  );
};

export default CustomLegend;
